import {
	Component,
	Input,
	OnDestroy,
	Output,
	EventEmitter,
	ViewChild
} from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ChartsEvent, KngCharts, KngChartsState } from './definitions';
import { BaseChartDirective } from 'ng2-charts';
import { KngChartsFactory } from './kng-charts.factory';
import { LibIcons } from '../../constants/global.constant';
import { KngLoaderState } from '../loader';
import { WidgetsComingSoon } from '../../shared/shared.interface';

@Component({
	selector: 'kng-charts',
	templateUrl: './template/kng-charts.component.html',
	styleUrls: ['./template/kng-charts.component.scss']
})
export class KngChartsComponent implements KngCharts, OnDestroy 
{
	private subscriptions: Subscription = new Subscription();
	private state$: BehaviorSubject<KngChartsState> =
		new BehaviorSubject<KngChartsState>(KngChartsFactory.buildState());

	@Input() set state(value: KngChartsState) 
	{
		this.state$.next(value);
	}
	loaderState: KngLoaderState = {
		imagePath: LibIcons.widgetLoader
	};
	comingSoon:WidgetsComingSoon = {
		imagePath: '/assets/widgetsComingSoon.png',
		imageText: 'Coming Soon'
		
	};

  
	get state(): KngChartsState 
	{
		return this.state$.value;
	}
	@Output() stateChanged: EventEmitter<KngChartsState> =
		new EventEmitter<KngChartsState>();

	@Output() ctaLinkClicked: EventEmitter<ChartsEvent> =
		new EventEmitter<ChartsEvent>();

	@Output() tooltipClicked: EventEmitter<void> =
		new EventEmitter<void>();
	@ViewChild(BaseChartDirective) chart!: BaseChartDirective;

	ngOnDestroy(): void 
	{
		this.destroySubscriptions();
	}

	private destroySubscriptions(): void 
	{
		this.subscriptions.unsubscribe();
	}

	ctaLinkClick(event: Event) 
	{
		const eventEmitted: ChartsEvent = {
			event: event,
			state: this.state
		};
		this.ctaLinkClicked.emit(eventEmitted);
	}
	showTooltip()
	{
		this.tooltipClicked.emit();
	}
}
